jQuery(document).ready(($) => {

    // show popup speaker
    // $('[data-counter]').toggleClass('hidden');
    $('[href="#view-all"]').on(
        'click',
        function() {
            let speakers = $('[data-counter]');
            if ($(this).data('action') == 'view-all') {
                $(this).data('action', 'hide-all');
                speakers.each(
                    (i,el) => {
                        $(el).removeClass('hidden');
                    }
                );
                $(this).text('Hide');

            } else {
                $(this).data('action', 'view-all');
                speakers.each(
                    (i,el) => {
                        let counter = $(el).data('counter');
                        console.log(counter);
                        console.log(get_speaker_visible_number());
                        if (counter > get_speaker_visible_number()) {
                            $(el).addClass('hidden');
                        } else {
                            $(el).removeClass('hidden');
                        }
                    }
                );
                $(this).text('View All');
            }
        }
    );

    function get_speaker_visible_number() {
        const width = $(document).width();
        let visible = 9;
        console.log(width);

        if (width <= 992) {
            visible = 8;
        }

        return visible;
    }

    function speaker_made_visible_for_popup() {
        // don't change the visibility if open
        if ($('[href="#view-all"').data('action') == 'hide-all') {
            return;
        }

        let speakers = $('[data-counter]');

        speakers.each(function(i,el) {
            let counter = $(el).data('counter');
            console.log(counter);
            console.log(get_speaker_visible_number());
            if (counter > get_speaker_visible_number()) {
                $(el).addClass('hidden');
            } else {
                $(el).removeClass('hidden');
            }
        });
    }

    speaker_made_visible_for_popup();

    $(window).on(
        'resize',
        speaker_made_visible_for_popup
    );

    // open search form
    $('.search-toggle').click(function(e) {
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            e.preventDefault();
            $('#search-container').toggleClass('hidden');
            // .toggleClass('flex');
            $('#search').focus();
        }
    });

    // search focus
    if($('#search-mobile').length) {
        $('#search-mobile').focus();
    }

    // submit search form
    $('#trigger-submit-form').click(function() {
        $(this).closest('form').submit();
    });

    // stop propagation
    $('#search, #trigger-submit-form').click(function(e) {
        e.stopPropagation();
    });

    // close search form
    $('#search-container').click(() => {
        $('#search-container').toggleClass('hidden');
    });

    // toggle menu mobile
    $('.menu-toggle').click(() => {
        $('#mobile-menu').slideToggle();
    });

    // toggle menu mobile event
    $('.menu-toggle-reserved').click(() => {
        $('.menu-nav-reserved').slideToggle();
    });

    // agenda init
    if($('.tabs-component').length > 0) {
        $('.tabs-component').each(function() {
            if($(this).find('.tab-header.today').length > 0) {
                $(this).find('.today').addClass('active');
                let index = $(this).find('.today').index();
                $(this).find('.tab-content').eq(index).addClass('active');
            } else {
                $(this).find('.tab-header').eq(0).addClass('active');
                $(this).find('.tab-content').eq(0).addClass('active');
            }
        });
    }

    // agenda toggle
    $('.tab-header').click(function() {
        let id = $(this).data('tab');
        $(this).closest('.tabs-component').find('.tab-header').removeClass('active');
        $(this).closest('.tabs-component').find('.tab-content').removeClass('active');
        $(this).addClass('active');
        $('#' + id).addClass('active');
    });

    // hour toggle
    $('.tab-hour-toggle').click(function() {
        $(this).closest('.tab-hour-container').toggleClass('active').find('.tab-hour-content').slideToggle();
    });

    // open box hour
    $('.tabs-content').each(function() {
        $(this).find('.tab-hour-container').addClass('active').find('.tab-hour-content').slideToggle();
    });


    function video_change_language() {
        let language = $(this).val();
        let video_id = language + '-video';
        let content_id = 'content-' + video_id;

        $('#events-player-content', this).hide();
        $('#events-player-content', this).empty();
        $('#events-player-content', this).html($('#' + content_id).data('video'));
        $('#events-player-content', this).find('iframe').on(
            'load',
            function() {
                $('#events-player-content').show();
            }
        );
    }

    // Language selector for single session video
    $('#language-selector').on(
        'change',
        video_change_language
    );

    $('a[href=#dropdown-previous]').click(function(e) {
        
        console.log('click');
        let $dropdown = $(this).siblings('.dropdown-menu');
        $(this).siblings('.dropdown-menu').removeClass('hidden');
        $(this).siblings('.dropdown-menu').addClass('open');

        if( !$(this).data('open') ) {
            $(this).data('open', true);
            $(this).addClass('open');
            $dropdown.removeClass('hidden');
            $dropdown.addClass('open');
        } else {
            $(this).data('open', false);
            $(this).removeClass('open');
            $dropdown.removeClass('open');
            $dropdown.addClass('hidden');
        }
        e.preventDefault();
        // $(this).siblings('.dropdown-menu').show();
    });

});

// Swiper main
new Swiper('.swiper-main.swiper-active', {
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    keyboard: {
        enabled: true,
    },
});

// Swiper quotes
new Swiper('.swiper-quotes', {
    loop: true,
    autoHeight: true,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    keyboard: {
        enabled: true,
    },
});


